import CustomFilterSelect from "./CustomFilterSelect";

const FilterDecision = (props: any) => {
  const FilterData = [
    { id: "Approved", name: "Approved" },
    { id: "Declined", name: "Declined" },
    { id: "Countered", name: "Countered" },
    { id: "Pre-Approved", name: "Pre-Approved" },
  ];
  return (
    <CustomFilterSelect
      source="sReview"
      label="Decision"
      choices={FilterData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterDecision;
